export default "__VITE_ASSET__444126ef__"